/**
 * TypingIndicator — three-dot pulse while the assistant is "thinking".
 *
 * The animation timing (1.2s loop, staggered 0.16s per dot) was tuned to
 * feel responsive but not frantic. The bubble container matches the visual
 * shape of an assistant ChatBubble so the layout doesn't jump when the
 * indicator is replaced by the real message.
 */
export default function TypingIndicator() {
  return (
    <div className="mb-3 flex items-end gap-2 animate-fade-in">
      <Avatar />
      <div className="rounded-2xl rounded-bl-md bg-bg-card px-4 py-3 ring-1 ring-stroke shadow-card">
        <div className="flex items-center gap-1.5">
          <Dot delay="0ms" />
          <Dot delay="160ms" />
          <Dot delay="320ms" />
          <span className="ml-2 text-2xs font-semibold uppercase tracking-widest-plus text-ink-tertiary">
            Oracle thinking…
          </span>
        </div>
      </div>
    </div>
  );
}

function Dot({ delay }) {
  return (
    <span
      className="inline-block h-1.5 w-1.5 rounded-full bg-f1-red animate-typing-bounce"
      style={{ animationDelay: delay }}
    />
  );
}

function Avatar() {
  return (
    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-f1-red to-f1-redDeep shadow-glow-red-soft">
      <span className="text-xs font-bold text-white">F1</span>
    </div>
  );
}
